import { MessageCircle, Instagram, Link2 } from "lucide-react";
import { toast } from "sonner";
import { copyText } from "@/lib/clipboard";

const btn =
  "inline-flex items-center gap-2 rounded-full border border-sand bg-cream text-cocoa text-sm px-5 py-2.5 hover:border-gold hover:text-gold transition-colors duration-200";

export default function ShareButtons({ post, url, align = "" }) {
  const link = url || `${window.location.origin}/novedades/${post.slug}`;
  const waText = `${post.title} — nueva novedad en ISI'S Nails 💅 ${link}`;
  const igText = `${post.instagram || post.excerpt || post.title}\n\n${link}`;

  const copy = async (text, msg) => {
    if (await copyText(text)) toast.success(msg);
    else toast.error("No se pudo copiar, hazlo a mano");
  };

  return (
    <div data-testid="share-buttons" className={`flex flex-wrap items-center gap-2 ${align}`}>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(waText)}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="share-whatsapp-btn"
        className={btn}
      >
        <MessageCircle className="w-4 h-4" /> WhatsApp
      </a>
      <button
        onClick={async () => {
          await copy(igText, "Texto y enlace copiados · pégalos en tu publicación o historia");
          window.open("https://www.instagram.com/", "_blank", "noopener");
        }}
        data-testid="share-instagram-btn"
        className={btn}
      >
        <Instagram className="w-4 h-4" /> Instagram
      </button>
      <button onClick={() => copy(link, "Enlace copiado")} data-testid="share-copy-btn" className={btn}>
        <Link2 className="w-4 h-4" /> Copiar enlace
      </button>
    </div>
  );
}
